import { createMongoAbility, createAliasResolver } from '@casl/ability';
import { USER_ACTIONS } from '@/utils/const';
import { ref } from 'vue';

const resolveAction = createAliasResolver({
  ['MODIFY']: [USER_ACTIONS.UPDATE, USER_ACTIONS.READ],
});

let ability = ref(null);

export default function useAbility() {
  return {
    init(rules = []) {
      ability.value = createMongoAbility(rules, { resolveAction });
    },
    destroy() {
      ability.value = null;
    },
    can(action, subject) {
      return ability.value?.can(action, subject);
    },
    get isAbility() {
      return Boolean(ability.value);
    },
  };
}
